export const IMAGES = {
  portrait: "/assets/platzhalter-arbeitsplatz.jpg",
};

export const AGENCY = {
  name: "Nordhorizont Digital",
  domain: "nordhorizont-digital.de",
  founder: "Jannik Lucas Deichmann",
  region: "Region Hamburg",
  email: "info@nordhorizont-digital.de",
  cta: "Kostenlose Analyse anfordern",
};

export const TRUST_FACTS = [
  { title: "Persönlicher Ansprechpartner", text: "Sie sprechen direkt mit Jannik, nicht mit einem Callcenter." },
  { title: "Online in maximal 24 Stunden", text: "KI-gestützte Umsetzung, verbindlich geplant." },
  { title: "Made in Hamburg", text: "Ansässig in der Region, erreichbar vor Ort." },
  { title: "Faire Festpreise", text: "KI-gestützter Prozess spart Zeit und damit Kosten." },
];

export const PROBLEMS = [
  {
    title: "Keine Website",
    text: "Wer Sie googelt und nichts findet, ruft beim nächsten Betrieb an. So einfach ist das leider.",
  },
  {
    title: "Veraltete Website",
    text: "Eine Seite von 2010 wirkt wie ein verstaubter Ausstellungsraum. Ihre Arbeit ist besser als ihr Auftritt.",
  },
  {
    title: "Nicht auffindbar, nicht mobil",
    text: "Die meisten Kunden suchen auf dem Handy. Wenn dort nichts lesbar ist, ist die Anfrage weg.",
  },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "Kostenlose Analyse",
    text: "Wir schauen uns Ihre aktuelle Web-Präsenz an, oder den Stand ganz ohne Website. Sie bekommen eine ehrliche Einschätzung, wo Anfragen verloren gehen.",
  },
  {
    num: "02",
    title: "Konzept & Design-Vorschlag",
    text: "Sie erhalten einen klaren Vorschlag für Aufbau, Texte und Gestaltung. Verständlich erklärt, ohne Fachchinesisch.",
  },
  {
    num: "03",
    title: "Umsetzung mit KI-gestützten Tools",
    text: "Moderne Werkzeuge beschleunigen die Entwicklung deutlich. Das macht den Preis fair und den Zeitplan verlässlich. Die Qualität bleibt Handarbeit.",
  },
  {
    num: "04",
    title: "Übergabe & Betreuung",
    text: "Sie bekommen alles fertig eingerichtet, inklusive Hosting-Empfehlung. Auf Wunsch übernehme ich auch die laufende Wartung.",
  },
];

export const PRICING = {
  website: {
    price: "949 €",
    interval: "einmalig",
    note: "Ihre komplette Website, fertig eingerichtet und online.",
    features: [
      "Individuelle Website (einmalige Erstellung)",
      "Mobil optimiert",
      "Bis ca. 5 bis 7 Seiten",
      "Kontaktformular",
      "Google Maps",
      "WhatsApp/Telefon-CTA",
      "Grundlegende Onpage-SEO",
      "Schnelle Ladezeiten",
      "Impressum/Datenschutz technisch einbindbar",
      "Korrekturschleife inklusive",
    ],
    legal: "Rechtliche Inhalte für Impressum und Datenschutz liefert bzw. prüft der Kunde.",
  },
  care: {
    price: "49 €",
    interval: "pro Monat",
    note: "Damit Ihre Website dauerhaft läuft und aktuell bleibt.",
    features: [
      "Laufende Betreuung",
      "Hosting",
      "Updates",
      "Kleinere Änderungen",
      "Support",
    ],
  },
};

export const WHY_POINTS = [
  {
    icon: "UserRound",
    title: "Persönlicher Kontakt statt Callcenter",
    text: "Ein Ansprechpartner von Anfang bis Ende. Kurze Wege, schnelle Antworten.",
  },
  {
    icon: "Zap",
    title: "KI-gestützter Prozess",
    text: "Schnellere Umsetzung, planbarer Festpreis. Sie zahlen für Ergebnis, nicht für Agentur-Overhead.",
  },
  {
    icon: "Building2",
    title: "Fokus auf den Mittelstand",
    text: "Ich kenne die Kundschaft kleiner und mittlerer Betriebe und weiß, worauf es bei Ihnen ankommt.",
  },
  {
    icon: "MapPin",
    title: "Zuhause in der Region Hamburg",
    text: "Erstgespräch gern auch vor Ort, bei Ihnen im Betrieb.",
  },
];

export const TIMELINE = [
  { step: "1", title: "Erstgespräch", time: "30 Minuten, unverbindlich", text: "Wir klären am Telefon oder vor Ort, was Sie brauchen und was sinnvoll ist." },
  { step: "2", title: "Angebot", time: "innerhalb von 2 Werktagen", text: "Sie erhalten ein schriftliches Festpreis-Angebot. Kein Kleingedrucktes." },
  { step: "3", title: "Umsetzung", time: "maximal 24 Stunden", text: "Design und Entwicklung, KI-gestützt. Ihre Website steht in maximal 24 Stunden." },
  { step: "4", title: "Launch", time: "gemeinsamer Livegang", text: "Ihre Website geht online, technisch sauber und auf allen Geräten getestet." },
  { step: "5", title: "Support danach", time: "dauerhaft erreichbar", text: "Änderungen, Fragen, Wartung. Ich bleibe Ihr Ansprechpartner." },
];

export const NAV_LINKS = [
  { label: "Ablauf", href: "#prozess" },
  { label: "Preise", href: "#preise" },
  { label: "Über mich", href: "#warum" },
  { label: "Kontakt", href: "#kontakt" },
];
